export default __webpack_public_path__ + "e3cc66842ed8e2220a38fdf65a6482db.svg";